export class UniloginBruger {
        public brugernavn: string;
        public navn: string;
        public email: string;
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/models/UniloginBruger.ts